//Active benefits
import activeHealthBenefits from '../data/enrollment/activeBenefits/healthBenefits.json';
import cobraHealthBenefits from '../data/enrollment/activeBenefits/cobraHealthBenefits.json';
import cobraSpendingAccountsBenefits from '../data/enrollment/activeBenefits/cobraSpendingAccounts.json'
import activeLifeAndDisability from '../data/enrollment/activeBenefits/lifeAndDisability.json';
import activeSpendingAccounts from '../data/enrollment/activeBenefits/spendingAccounts.json';
import activeLifestyleBenefits from '../data/enrollment/activeBenefits/lifestyleBenefits.json';
//Health Benefits
import dentalBenefits from '../data/enrollment/availableBenefits/healthBenefits/dental.json';
import criticalIllness from '../data/enrollment/availableBenefits/healthBenefits/criticalIllness.json';
import accidentInsurance from '../data/enrollment/availableBenefits/healthBenefits/accident-insurance.json';
import hospitalIndemnity from '../data/enrollment/availableBenefits/healthBenefits/hospitalIndemnity.json';
import healthSavings from '../data/enrollment/availableBenefits/healthBenefits/healthSavings.json';
import medicalBenefits from '../data/enrollment/availableBenefits/healthBenefits/medical.json';
import cobraMedicalBenefits from '../data/enrollment/availableBenefits/healthBenefits/cobra-medical.json'
import cobraDentalBenefits from '../data/enrollment/availableBenefits/healthBenefits/cobra-dental.json'
import cobraVisionBenefits from '../data/enrollment/availableBenefits/healthBenefits/cobra-vision.json'
import nonTobaccoUserCredits from '../data/enrollment/availableBenefits/healthBenefits/nonTobaccoUserCredit.json';
import spousalSurcharges from '../data/enrollment/availableBenefits/healthBenefits/spousalSurcharge.json';
import visionBenefits from '../data/enrollment/availableBenefits/healthBenefits/vision.json';
//Life and Disability Insurances
import baseLifeInsurances from '../data/enrollment/availableBenefits/lifeAndDisabilityInsurance/baseLife.json';
import longtermDisabilities from '../data/enrollment/availableBenefits/lifeAndDisabilityInsurance/longtermDisability.json';
import optionalLifeInsurances from '../data/enrollment/availableBenefits/lifeAndDisabilityInsurance/optionalLife.json';
import spouseLifeInsurances from '../data/enrollment/availableBenefits/lifeAndDisabilityInsurance/spouseLife.json';
//Spending Accounts
import dependantCare from '../data/enrollment/availableBenefits/spendingAccounts/dependantCare.json';
import healthCare from '../data/enrollment/availableBenefits/spendingAccounts/healthCare.json';
//Lifestyle Benefits
import legalServices from '../data/enrollment/availableBenefits/lifestyleBenefits/legalServices.json';
//Covered family members
import coveredFamilyMembers from '../data/enrollment/coveredMembers/coveredMembers.json'
//Profiles utility
import { mapProfileIds, getAllProfiles } from './profiles';
import { COBRA_PERSONAS } from '../utils/utils';

const allAvailablePlansView = [
  ...dentalBenefits['data']['plans'],
  ...accidentInsurance['data']['plans'],
  ...medicalBenefits['data']['plans'],
  ...visionBenefits['data']['plans'],
  ...nonTobaccoUserCredits['data']['plans'],
  ...spousalSurcharges['data']['plans'],
  ...baseLifeInsurances['data']['plans'],
  ...optionalLifeInsurances['data']['plans'],
  ...spouseLifeInsurances['data']['plans'],
  ...longtermDisabilities['data']['plans'],
  ...healthCare['data']['plans'],
  ...dependantCare['data']['plans'],
  ...criticalIllness['data']['plans'],
  ...hospitalIndemnity['data']['plans'],
  ...legalServices['data']['plans'],
  ...healthSavings['data']['plans'],
];

const getGenericInfoByType = (type: string) => {
  switch (type) {
    case 'medical': {
      return medicalBenefits['data']['generic'];
    }
    case 'dental': {
      return dentalBenefits['data']['generic'];
    }
    case 'accident-insurance': {
      return accidentInsurance['data']['generic'];
    }
    case 'vision': {
      return visionBenefits['data']['generic'];
    }
    case 'spousal-surcharge': {
      return spousalSurcharges['data']['generic'];
    }
    case 'non-tobacco-user-credit': {
      return nonTobaccoUserCredits['data']['generic'];
    }
    case 'base-life': {
      return baseLifeInsurances['data']['generic'];
    }
    case 'spouse-life': {
      return spouseLifeInsurances['data']['generic'];
    }
    case 'long-term-disability': {
      return longtermDisabilities['data']['generic'];
    }
    case 'health-care': {
      return healthCare['data']['generic'];
    }
    case 'dependant-care': {
      return dependantCare['data']['generic'];
    }
    case 'critical-illness': {
      return criticalIllness['data']['generic'];
    }
    case 'hospital-indemnity': {
      return hospitalIndemnity['data']['generic'];
    }
    case 'legal-services': {
      return legalServices['data']['generic'];
    }
    case 'health-savings': {
      return healthSavings['data']['generic'];
    }
    case 'optional-life': {
      return optionalLifeInsurances['data']['generic'];
    }
  }
};

const getPlanById = (planId: string) => {
  return allAvailablePlansView.find(({ id }) => id === planId);
};

const getAvailablePlans = (planId: string) => {
  return allAvailablePlansView.filter(
    (plan) => plan.id.includes(planId.split('-')[0])
  );
};

export const getActiveHealthBenefits = (selectedPersona?: string) => {
  let benefits = activeHealthBenefits;
  if(selectedPersona && COBRA_PERSONAS.indexOf(selectedPersona) > -1) {
    benefits = cobraHealthBenefits;
  }

  return mapProfileIds(
    benefits['data'].map((benefit: any) => {
      const plan = getPlanById(benefit['planId']);
      const availablePlans = getAvailablePlans(benefit['planId']);
      return {
        ...benefit,
        plan: {
          ...plan,
          originalCost: plan?.cost,
        },
        availablePlans: availablePlans,
        generic: getGenericInfoByType(benefit['type']),
      };
    })
  );
};

export const getCoveredFamilyMembers = () => {
  return mapProfileIds(
    coveredFamilyMembers['data'].map((benefit: any) => {
      const plan = getPlanById(benefit['planId']);
      return {
        ...benefit,
        plan: {
          ...plan,
          originalCost: plan?.cost,
        },
        generic: getGenericInfoByType(benefit['type']),
      };
    })
  );
}

export const getActiveLifestyleBenefits = () => {
  return mapProfileIds(
    activeLifestyleBenefits['data'].map((benefit: any) => {
      const plan = getPlanById(benefit['planId']);
      const availablePlans = getAvailablePlans(benefit['planId']);
      return {
        ...benefit,
        plan: {
          ...plan,
          originalCost: plan?.cost,
        },
        availablePlans: availablePlans,
        generic: getGenericInfoByType(benefit['type']),
      };
    })
  );
};

export const getActiveSpendingAccounts = (selectedPersona?: string) => {
  let benefits = activeSpendingAccounts;
  if(selectedPersona && COBRA_PERSONAS.indexOf(selectedPersona) > -1) {
    benefits = cobraSpendingAccountsBenefits;
  }

  return mapProfileIds(
    benefits['data'].map((benefit: any) => {
      const plan = getPlanById(benefit['planId']);
      return {
        ...benefit,
        plan: {
          ...plan,
          originalCost: plan?.cost,
        },
        generic: getGenericInfoByType(benefit['type']),
      };
    })
  );
};

export const getActiveLifeAndDisabilityInsurances = () => {
  return mapProfileIds(
    activeLifeAndDisability['data'].map((benefit: any) => {
      const plan = getPlanById(benefit['planId']);
      const availablePlans = getAvailablePlans(benefit['planId']);
      return {
        ...benefit,
        plan: {
          ...plan,
          originalCost: plan?.cost,
        },
        availablePlans: availablePlans,
        generic: getGenericInfoByType(benefit['type']),
      };
    })
  );
};

export const getFamilyMembers = () => {
  return getAllProfiles()['data'];
};

export const getAllMedicalBenefits = () => {
  return medicalBenefits['data'];
};

export const getAllCobraMedicalBenefits = () => {
  return cobraMedicalBenefits['data'];
};

export const getAllDentalBenefits = () => {
  return dentalBenefits['data'];
};

export const getAllCobraDentalBenefits = () => {
  return cobraDentalBenefits['data'];
};

export const getAllVisionBenefits = () => {
  return visionBenefits['data'];
};

export const getAllCobraVisionBenefits = () => {
  return cobraVisionBenefits['data'];
};

export const getAllNonTobaccoUserCredits = () => {
  return nonTobaccoUserCredits['data'];
};

export const getAllSpousalSurcharges = () => {
  return spousalSurcharges['data'];
};

export const getAllBaseLifeInsurances = () => {
  return baseLifeInsurances['data'];
};

export const getAllOptionalLifeInsurances = () => {
  return optionalLifeInsurances['data'];
};

export const getAllSpouseLifeInsurances = () => {
  return spouseLifeInsurances['data'];
};

export const getAllLongtermDisabilities = () => {
  return longtermDisabilities['data'];
};

export const getAllHealthCare = () => {
  return healthCare['data'];
};

export const getAllDependantCare = () => {
  return dependantCare['data'];
};

export const getAllCriticalIllness = () => {
  return criticalIllness['data'];
};

export const getAllAccidentInsuranceBenefits = () => {
  return accidentInsurance['data'];
};

export const getAllHospitalIndemnity = () => {
  return hospitalIndemnity['data'];
};

export const getAllLegalServices = () => {
  return legalServices['data'];
};

export const getAllHealthSavings = () => {
  return healthSavings['data'];
};
